import { Layout } from "antd";
const { Header } = Layout;

function HeaderComponent() {
	return <Header className="header">Header</Header>;
}

export default HeaderComponent;
